import { render } from "./travelAdmin.vue?vue&type=template&id=62e82177&scoped=true"
import script from "./travelAdmin.vue?vue&type=script&lang=js"
export * from "./travelAdmin.vue?vue&type=script&lang=js"

import "./travelAdmin.vue?vue&type=style&index=0&id=62e82177&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-62e82177"

export default script